import troubles from "./bs_troubles";
export default [
  [
    {
      q: "为什么搜不到车辆？",
      a:
        "1.请检查车辆是否处于启动状态，并处于P档。<br/>\
      2.请检查手机蓝牙功能是否处于已开启状态。（由于Android10系统BUG，Android10系统版本用户需要开启定位功能）。<br/>\
      3.请检查车辆是否正处于待绑定状态。<br/>\
      为保证您的车辆安全，车辆进入待激活状态后，若5分钟内无任何操作、被推行或驾驶，车辆将自动退出待激活状态，或导致无法搜索到车辆。<br/>\
      您可通过再次启动车辆，在特定时间内通过APP搜索完成激活操作。"
    },
    {
      q: "点击连接搜索到的车辆，但是提示连接失败？",
      a:
        "1.请检查车辆是否正处于待绑定状态。<br/>\
      为保证您的车辆安全，车辆进入待激活状态后，若5分钟内无任何操作、被推行或驾驶，车辆将自动退出待激活状态，或导致无法搜索到车辆。<br/>\
      您可通过再次启动车辆，在特定时间内通过APP搜索完成激活操作。<br/>\
      2.可能是由于您手机蓝牙的信号不稳定。造成连接困难。您可以尝试重新搜索后再次尝试连接车辆。"
    },
    {
      q: "搜索到多辆车，如何确定需要激活目标车辆？",
      a:
        "您可以通过对照车架号，来确定您要激活的是哪辆车。车架号在您车辆座桶内充电口附近，如下图：\
      <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"
    },
    {
      q: "一直显示“车辆网络激活中…”，该怎么办？",
      a:
        "1.请检查您的车辆网络是否正常。<br/>\
      您可通过车辆屏幕查看网络状态，若发现车辆网络状态不好，建议您将车辆移至开阔的室外环境或网络良好的环境下。<br/>\
      2.请检查您的手机网络是否正常。<br/>\
      可能由于您的手机网络异常或不稳定，导致激活状态未能及时同步。<br/>\
      3.检查您蓝鲨APP的“通知权限”是否开启。您可尝试前往手机设置中心→通知→蓝鲨APP→打开通知权限；（由于手机系统版本差异，操作流程可能存在差异）<br/>\
      4.您可尝试在蓝鲨APP内退出账号并重新登录来解决这个问题。"
    },
    {
      q: "激活绑定后，就完成了手机与车辆的蓝牙连接吗？",
      a:
        "激活绑定后，手机与车辆仅完成了BLE（低功耗蓝牙）模块的连接，用于手机与车辆的基本通讯。<br/>\
      如需通过蓝牙连接，使用音乐或电话等蓝牙相关功能，请前往手机系统设置中，通过手机蓝牙搜索进行连接。"
    },
    {
      q: "如何解绑车辆？",
      a:
        "登录蓝鲨app，从APP侧边栏选择要解绑的车辆，点击删除车辆，勾选删除协议后点击删除即可成功解除绑定。"
    },
    {
      q: "APP解绑车辆后，车辆无法进入待激活状态？",
      a:
        "APP解绑后，车辆无法重新进入待激活状态，可能是因为当前车辆网络不佳导致的：<br/>\
      1.您可将车辆停放在环境开阔，网络较好的位置，并重启车辆查看状态；<br/>\
      2.检查车辆智能服务是否到期，若智能服务已到期，请续费后，重启车辆进行查看。"
    }
  ],
  [
    {
      q: "如何更换/解绑手机号？",
      a:
        "为保证您的账户安全，激活车辆后务必需要绑定手机号，因此激活车辆的账号不支持直接解绑，仅支持更换成其他手机号。<br/>\
      如需更换，您可使用APP点击设置，进入账号安全中心，对账号绑定进行管理，点击手机号进行变更即可。"
    },
    {
      q: "一个账号可以多个设备使用吗？",
      a:
        "蓝鲨账号登录是不限制手机设备的，但是为了保护账号安全及车辆安全，不支持一个账号同时在多个手机设备上使用，否则可能会被自动退出。"
    },
    {
      q: "如何注销账号？",
      a:
        "蓝鲨APP支持账号注销，但您需要确保该账户下已无绑定车辆，且无未完成或未支付的服务。<br/>\
      您可点击设置→账号安全→账户注销，进行账号的注销。<br/>\
      注销账号是不可恢复的操作，请您谨慎操作。注销成功后，您将无法登陆或使用蓝鲨账号内的所有信息。"
    },
    {
      q: "如何管理车辆的数据权限？",
      a:
        "蓝鲨非常重视您的隐私保护和个人信息的保护。<br/>\
      您可以利用蓝鲨电动实现但不限于查看车况，定位车辆，定位您所在的位置、车辆动态记录，以及遥控车辆，设置车辆等功能。<br/>\
      在秉着“最小化”原则的前提下，我们将直接或间接获取您的车辆的定位及行驶轨迹信息，并做加密处理。<br/>\
      您可以通过进入车辆管理界面，选择“车辆数据与权限”功能进行权限的管理。相应功能禁用后，可能导致部分功能无法正常使用。"
    }
  ],
  [
    {
      q: "骑行之前，需要做哪些准备？",
      a:
        "为保证您的骑行安全，请在骑行前做如下准备：<br/>\
      1.检查⻋辆能否正常通电，灯光照明等状态是否正常；<br/>\
      2.检查前、后刹⻋能否正常⼯作；<br/>\
      3.检查轮胎的⽓压是否正常；<br/>\
      4.检查⻋把及前后轮是否固定，⻰头锁是否已解锁；<br/>\
      5.保证电池电量充⾜；<br/>\
      6.是否存在其他故障提示；<br/>\
      7.佩戴好头盔及其他符合要求的护具。"
    },
    {
      q: "如何启动车辆？",
      a:
        "请通过以下三种任⼀⽅式启动车辆：<br/>\
      1.遥控钥匙：(1) 点击遥控器上的开锁按钮；(2) 靠近⻋辆后长按车辆屏幕下⽅电源按键；<br/>\
      2.⼿机：(1) 打开⼿机 App 点击“⼀键撤防”；(2) ⻋辆绑定⼿机，靠近⻋辆待屏幕上蓝⽛标志亮起，点按屏幕下⽅按键启动；<br/>\
      3.指纹（仅限 R1 ⻋型）：输⼊驾驶员指纹后，⽆需随身携带钥匙或⼿机，使⽤对应⼿指触摸屏幕下⽅指纹识别区启动车辆。"
    },
    {
      q: "为什么车辆启动后，拧转把没有动力？",
      a:
        "为了保护您的骑行安全，避免飞车等风险状况发生，车辆通过传感器对起步进行了安全限制。<br/>\
      您在骑行前，需要收起侧撑或中撑，并坐在车辆上。<br/>\
      并按下右手把“READY”键，此时“READY”指示灯亮起，车辆将进入待骑行状态。此时，您可通过拧动转把为车辆提供动力。<br/>\
      以上功能，可以通过手机APP的车辆中心（或R1 车型车机内的ADAS功能）进行开关设置。"
    },
    {
      q: "结束骑行后，需要做哪些事情？",
      a:
        "到达目的地后，点按“READY”键取消 READY 模式，并放下侧撑或中撑。<br/>\
      您可通过以下四种任一方式为车辆上锁：<br/>\
      1.遥控器：点击遥控器上的上锁按钮；<br/>\
      2.⼿机：打开⼿机 App，点击“设防”为车辆上锁；<br/>\
      3.⻋身：短按⻋辆把⼿上的设防按键或静⾳设防键。<br/>\
      车辆上锁后，请将车辆龙头转至左转向并检查龙头锁是否锁定。"
    }
  ],
  [
    {
      q: "什么是电子侧撑感应功能？",
      a:
        "为保证您的骑行安全，电子侧撑感应功能（R1 车型的起步安全功能）用于检测侧撑支起或收起的状态。当您准备骑行时，电子侧撑感应功能将会提醒您收起侧撑后开始骑行。<br/>该功能可通过车辆设置开启或关闭，建议新手用户保持该功能的开启。"
    },
    {
      q: "什么是座垫重力检测功能？",
      a:
        "为保证您的骑行安全，座垫重力检测功能（R1 车型的轻松启动功能）用于检测车辆上是否已坐了人。当您准备骑行时，座垫重力检测功能将会提醒您坐稳后开始骑行。<br/>\
      该功能可通过车辆设置开启或关闭，建议新手用户保持该功能的开启。"
    },
    {
      q: "什么是转向辅助功能？",
      a:
        "为保证您的骑行安全，转向辅助功能可以在您转向过程中，激活后方摄像头，呈现车辆后方的路况信息，以弥补因视觉盲区所带来的转向风险。<br/>\
      （该功能目前仅R1 车型支持）"
    },
    {
      q: "什么是倒车辅助功能？",
      a:
        "为保证您的骑行安全，倒车辅助功能可以在您倒车过程中，激活后方摄像头及后方超声雷达，呈现车辆后方的障碍物及障碍物的距离，以弥补因视觉盲区所带来的倒车风险。<br/>\
      （该功能目前仅R1 车型支持）"
    }
  ],
  [
    {
      q: "如何连接手机蓝牙？",
      a:
        "（目前该功能仅支持R1 车型）<br/>\
      1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
      2.选择“手机”并开启蓝牙功能，选择连接手机；<br/>\
      3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
      4.通过车机选择自己的手机设备并连接；<br/>\
      5.车机具有蓝牙记忆功能，连接过的手机设备在下一次接近车机时，会自动连接。（IOS设备在不关闭手机蓝牙开关的情况下，支持记忆功能，Android设备不受手机蓝牙开关影响）<br/>\
      6.若要断开链接，选择断开相应的设备即可；<br/>\
      7.若搜到不到您的手机设备，请确认手机蓝牙是否开启，并确认手机是否处于蓝牙页面。若仍未搜索到，可尝试关闭“蓝牙开关”再重新打开。"
    },
    {
      q: "如何连接蓝牙耳机或蓝牙头盔？",
      a:
        "（目前该功能仅支持R1 车型）<br/>\
      1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
      2.选择“耳机/头盔”并开启蓝牙功能，选择您的设备名称并连接；<br/>\
      3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
      4.若要断开链接，选择断开相应的设备即可。"
    },
    {
      q: "如何使用蓝牙音乐功能？",
      a:
        "（目前该功能仅支持R1 车型）<br/>\
      1.请确保车辆已经连接了您的手机和耳机/头盔，若未连接耳机/头盔，音乐将通过车载音响进行外放；<br/>\
      2.使用手机播放音乐后，无论是驻车模式还是行车模式，你都可以通过车机选择并播放您的音乐；<br/>\
      3.您可通过车机上的播放/暂停键执行播放和暂停指令，点击OK键播放下一曲，点按音量加减键放大或缩小音量。"
    },
    {
      q: "如何使用蓝牙电话功能？",
      a:
        "（目前该功能仅支持R1 车型）<br/>\
      1.在车辆驻车状态下，打开智能菜单选择蓝牙电话功能；<br/>\
      2.请确保车辆已经连接了您的手机和耳机/头盔，需要您耳机/头盔的麦克风进行通话。<br/>\
      3.选择“同步通讯录”，将手机的最近联系人和通话记录同步到车机上；<br/>\
      4.我们为您提供了“最近联系人”“所有通话”“未接来电”三个选项，你可以在驻车状态下进行外呼。<br/>\
      最近联系人：车辆读取手机通讯录中最近有过通话的10个人；<br/>\
      所有通话：车辆显示最近3天的通话记录（最多20条）；<br/>\
      未接来电：车辆在所有通话中筛选出所有未接来电（最多20条）；<br/>\
      5.若有人向你呼入通话，你可通过按车机上的OK键接通，或使用“返回”键挂断。"
    }
  ],
  [
    {
      q: "关于车辆定位的问题",
      a:
        "车辆是通过卫星的GPS信号获得定位。车辆在室内或地库等封闭区域时，将影响车辆定位的准确性。将车辆移至开阔的坏境，GPS定位功能将恢复。<br/>\
      车辆轨迹是车辆在规定时间内上报的定位点一次连线形成的车辆轨迹。由于定位偏移以及信号遮挡，会造成捕捉到错误的定位甚至丢失定位点的情况，导致轨迹异常或不准确的情况。<br/>\
      若长时间不能定位或大部分轨迹异常，请检查车辆智能服务是否到期，若未到期，可联系售后检查车辆的网络及GPS的情况。"
    },
    {
      q: "无法收到消息推送怎么办？",
      a:
        "您可以通过以下操作进行排查：<br/>\
      1.请您确认首页右上角消息中心列表里是否可以收到相应的推送消息，如车辆震动；<br/>\
      2.管理手机的通知设置：您可前往手机设置中心，选择通知功能，选择蓝鲨APP，确认相应的功能已经开启。<br/>\
      3.蓝鲨APP内选择车辆，选择车辆安防模式，查看相应的通知推送是否开启。"
    },
    {
      q: "什么是车辆的安防模式？",
      a:
        "为保证您的车辆安全，针对车辆的异常动向进行了消息推送提醒，包括车辆的震动、轮动、电池断开、电池过放等。<br/>\
      您可以根据车辆的停放风险，选择警戒模式或勿扰模式，进行安防的个性化设置。<br/>\
      当车辆发生异动，可通过查看车辆定位，查看车辆当前位置，确保车辆的安全。"
    },
    {
      q: "预计行驶里程计算不准确的问题",
      a:
        "车辆的预计行驶里程，是根据用户的驾驶习惯于耗电量的情况综合统计而来的。影响预估里程准确性有多种原因，例如载物的情况、道路情况以及环境温度等，通常偏差值在20%之间属于正常现象。<br/>如果有明显偏大或偏小的情况，通常不是电池出了问题，而是在数据统计端由于数据稳定性或数据错误导致的。若骑行数次后仍存在偏差大的问题，可联系售后进行问题的排查。"
    },
    {
      q: "车辆远程控制没有反应怎么办？",
      a:
        "请您查看当前手机网络是否正常，并查看蓝鲨app首页右上角蓝牙和网络是否连接正常。若网络或蓝牙状态任意一个连接正常的情况下均可下发远程控制指令。"
    }
  ],
  [
    {
      q: "车辆升级有什么用?",
      a:
        "车辆OTA升级主要用于改善用车体验，优化车辆功能，每次车辆OTA升级，会提示车辆升级的功能组件，每次升级的内容请以升级当时的页面为准。"
    },
    {
      q: "车辆升级需要具备哪些条件？",
      a:
        "1.确保车辆已启动，并处于驻车状态。并保证车内的电池总电量大于20%，升级期间切勿不要移除电池。<br/>\
      2.确保手机的蓝牙功能及无线网络功能处于开启状态，并靠近车辆，保持手机与车辆处于连接状态。"
    },
    {
      q: "车辆升级期间需要注意哪些事项？",
      a:
        "1.车辆升级期间，请不要驾驶车辆，并确保车辆处于开启且非骑行状态；<br/>\
      2.车辆升级期间，请勿远离车辆，并保持车辆与手机一直处于连接状态；<br/>\
      3.车辆升级开始后，请勿移除车辆电池；<br/>\
      4.车辆升级开始后，请勿关闭屏幕和蓝鲨APP，并保持手机无线网络及蓝牙功能处于开启状态。"
    },
    {
      q: "为什么传输文件总是中断？",
      a:
        "R1 车型升级过程中，手机通过WiFi网络与车辆连接进行文件传输。在文件传输过程中，手机处于无网络状态，传输完成后恢复手机网络。<br/>\
      IOS手机用户，会提醒用户检测到当前网络状态不佳，是否断开或切换网络，请选择继续使用当前网络；<br/>\
      部分Android手机用户，请关闭“自动选择最近WLAN”功能，暂定因连接性或信号强度检测，自动断开或切换网络的功能，待文件传输完成后重新开启即可。"
    },
    {
      q: "升级结束了，但是不知道是否成功怎么办？",
      a:
        "车辆升级期间，请不要远离车辆，并保持蓝牙处于连接状态。<br/>\
      R1 车型的升级结果，会在车机端呈现；<br/>\
      R1 lite车型在升级过程通过蓝牙通讯，告知手机端当前车辆的升级状态。因此，在车辆升级过程中，切勿远离车辆或关掉APP。<br/>\
      若因特殊情况，断开了连接，可尝试重新连接车辆。或刷新系统升级页面，查看当前车辆版本，若均显示“已是最新版本”则升级成功，若部分升级组件仍不是最新版本，请重新升级。"
    }
  ],
  [
    {
      q: "如何给电池充电？",
      a:
        "蓝鲨 R 系列智能电动摩托⻋有两种快速充电⽅式：<br/>\
      1.座充：<br/>\
      请将充电底座请放置在⽔平平⾯，充电前请确保充电环境⽆温度过⾼过低、潮湿等情况；<br/>\
      将直充充电器与电源连接，再将充电底座与直充充电器连接，将电池正确放置在底座上，即可开始充电。当需要同时充两块电池时，请将分线器分别与充电器和两个充电底座相连接。<br/>\
      该充电底座需要与直充充电器配合使⽤。<br/>\
      2.直充<br/>\
      可以直接在⻋内直充，将电源插⼊充电接⼝，可以通过仪表屏电量显示确认电池是否充满。"
    },
    {
      q: "电池使用期间有哪些注意事项？",
      a:
        "1.电池使用环境：<br/>\
      请在 -10~45℃ 环境下使⽤；<br/>\
      避免被液体浸湿；<br/>\
      避免⾦属异物进⼊电池仓；<br/>\
      避免让电池靠近明⽕、易燃易爆⽓体。<br/>\
      2.电池容量衰减：<br/>\
      在低温情况下，电池可⽤容量会有不同程度的衰减，参考值为：<br/>\
      -10 ℃ 可⽤容量约为 70%；<br/>\
      0 ℃ 可⽤容量约为 85%；<br/>\
      25 ℃ 可⽤容量约为 100%；<br/>\
      3.电池安全注意事项：<br/>\
      如电池出现异常，如发热、变形或产⽣异味，请⽴即停⽤并远离电池，<br/>\
      联系售后部⻔进⾏检修，不可私⾃拆解电池。如擅⾃拆解电池，有可能会发⽣起⽕、爆炸等安全事故，同时⾃动失去三包资格。"
    },
    {
      q: "如何延长电池的使用寿命？",
      a:
        "电池的寿命主要是由电池充电循环次数和使用存储环境决定的，充电循环是指当电量为100%，电池完整放电一次再重新充满记做一次充电循环。良好的使用习惯，随用随充，50%电量存放，温度在0℃~25℃之间的干燥环境存放，避免过放可以有效的延长电池的使用寿命。"
    }
  ],
  [
    {
      q: "车辆的保养方法",
      a:
        "1.定期保养的实施<br/>\
      定期保养可以有效延⻓⻋辆使⽤寿命。请⽤户每 6 个⽉或 12 个⽉对⻋辆进⾏保养。<br/>\
      未进⾏定期保养，⻋辆可能存在安全隐患，带来故障或事故。定期保养过程中，如果发现⻋辆存在故障，请到蓝鲨指定⻔店或售后服务⽹点进⾏检修。<br/>\
      2.定期保养的方法<br/>\
      随车附带的说明书介绍了⼀些主要的检查项⽬，更详细的检修⼯作，请到蓝鲨指定⻔店、售后服务⽹点，或根据蓝鲨售后服务⼿册要求进⾏实施。<br/>\
      在定期保养时，请注意安全并遵守下述内容∶<br/>\
      在进⾏定期保养⼯作前，请选择地⾯平坦且空间宽阔的场所，撑起中撑后进⾏保养⼯作。<br/>\
      ⻓时间骑⾏后的⻋辆电⼦部件易发热，请勿⽴即拆解部品，否则容易发⽣破损。<br/>\
      定期保养中，如果发现⻋辆有异常，请及时进⾏调整，如未能⾃⾏处理异常情况，请到蓝鲨指定⻔店或售后服务⽹点进⾏全⾯检查。"
    }
  ],
  [
    {
      q: "车辆不能启动了怎么办？",
      a:
        "第一步：<br/>\
      检查电源开关是否开启，若无，请打开车辆电源开关；<br/>\
      第二步：<br/>\
      检查车辆遥控钥匙是否有电，可通过检查遥控钥匙上的指示灯是否不亮或闪烁，若无，请更换遥控钥匙电池；<br/>\
      第三步：<br/>\
      查看车辆电池是否已安装，若无，请装入有充足电量的电池；若电池电量不足，请按照指示方法进行充电。<br/>\
      若通过以上方法，仍然无法启动车辆，请联系指定门店或服务网点进行检查并修理。"
    },
    {
      q: "为什么充电后行驶里程变短？",
      a:
        "第一步：<br/>\
      检查是否有轮胎破损或气压不足的情况，若发现有，请更换轮胎或给轮胎充气；<br/>\
      第二步：<br/>\
      是否使用车辆的环境温度过低，行驶环境温度过低会降低电池放电效率，此为正常现象；同时，请保证充电环境温度在5℃到55℃之间；<br/>\
      第三步：<br/>\
      检查电池充电时间是否太短，并确定充电方法是否正确，并确认充电插头是否正确连接；<br/>\
      *电池多次充放电后，总容量会出现一定程度的衰减，此为正常现象；<br/>\
      若以上情况均已排查，仍无法解决，请将车辆推到指定⻔店或服务⽹点进⾏检查并修理。"
    },
    {
      q: "充电器充电过程有发热现象",
      a:
        "一般充电器在充电过程中温度均会上升，属于正常现象。<br/>\
      若充电器过热，以至于无法用手触碰，请立刻切断电源停⽌充电，将充电器送到指定⻔店或售后⽹点进⾏检查并修理。"
    },
    { q: "故障码及处理意见", a: troubles }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/bs_questions.js